import { client, formatQueryParams } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = async ({ fspId, ...params }) =>
  client.fsps(fspId).insightEvents.query(formatQueryParams(params));
